import { useCallback, useState } from "react";

import dynamic from "next/dynamic";

import classNames from "classnames/bind";
import type { ResolvedFooterContent } from "resolvers/base/footerContentResolver";

import ObserverPixel from "../ObserverPixel";
import styles from "./Footer.module.scss";
import FooterLinksSection from "./FooterLinksSection";
import FooterSocialSection from "./FooterSocialSection";
import FooterSubscribeSection from "./FooterSubscribeSection";

const FooterLegalSection = dynamic(() => import("./FooterLegalSection"), { ssr: false });
const cx = classNames.bind(styles);

export type FooterProps = ResolvedFooterContent & { trackingId?: string | null };

const Footer = (props: FooterProps) => {
    const {
        footerMainTitle,
        footerMenu,
        legalMenu,
        social,
        text,
        socialText,
        footerSignupSection,
        trackingId,
        hideFooterSignupForm,
    } = props;

    const [footerMenuOpen, setFooterMenuOpen] = useState<string | null>(null);

    const handleSetActiveFooterMenu = useCallback(
        (menuName: string) => {
            setFooterMenuOpen(menuName === footerMenuOpen ? null : menuName);
        },
        [footerMenuOpen]
    );

    return (
        <footer className={cx("footerContainer")}>
            <FooterSocialSection socialContent={social} text={socialText} />
            {hideFooterSignupForm && <FooterSubscribeSection {...footerSignupSection} />}
            <FooterLinksSection
                footerMainTitle={footerMainTitle}
                footerMenu={footerMenu}
                footerMenuOpen={footerMenuOpen}
                handleSetActiveFooterMenu={handleSetActiveFooterMenu}
            />
            <FooterLegalSection legalMenuContent={legalMenu} text={text} />
            <ObserverPixel uid={trackingId} />
        </footer>
    );
};

export default Footer;
